import API from './api';

export const putUserData = userData =>
  API.put('/User', userData)
    .then(res => res)
    .catch(err => {
      throw err;
    });

export const getUserData = () =>
  API.get('/User')
    .then(res => res)
    .catch(err => {
      throw err;
    });

export const updateLastAccess = () =>
  API.patch('/User/lastAccess')
    .then(res => res)
    .catch(err => {
      throw err;
    });

export const showWelcome = () =>
  API.get('/User/showWelcome')
    .then(res => res)
    .catch(err => {
      throw err;
    });

export const postFirstAccess = () =>
  API.post('/User/setFirstAccess')
    .then(res => res)
    .catch(err => {
      throw err;
    });

export const putUserPassword = ({ newPassword, oldPassword }) =>
  API.put('/User/updatePassword', { newPassword, oldPassword })
    .then(res => res)
    .catch(err => {
      throw err;
    });

export const putUserAvatar = avatar => {
  const formData = new FormData();
  formData.append('file', avatar);
  return API.put('/User/updateAvatar', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
    .then(res => res)
    .catch(err => {
      throw err;
    });
};

export const deleteUserAvatar = fileName =>
  API.delete(`/User/deleteAvatar/${fileName}`)
    .then(res => res)
    .catch(err => {
      throw err;
    });

export const recoverUserPassword = data =>
  API.post('/User/recoverPassword', `"${data.email}"`)
    .then(res => res)
    .catch(err => {
      throw err;
    });

export const checkValidToken = token =>
  API.get(`/User/canChangePassword/${token}`)
    .then(res => res)
    .catch(err => {
      throw err;
    });

export const putResetPassword = ({ token, newPassword }) =>
  API.put(`/User/changePassword/${token}`, `"${newPassword}"`)
    .then(res => res)
    .catch(err => {
      throw err;
    });

export const getUserAccessProfiles = () =>
  API.get('/User/getProfiles')
    .then(res => res)
    .catch(err => {
      throw err;
    });
